<template>

  <div>

    <div v-if="permissions.includes('manage_candidates')">
      
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To request a video questionnaire, select a job') }}
      </div>

      <div
        v-if="!candidate.email"
        class="alert alert-warning">
        O candidato não possui e-mail
      </div>

      <div
        v-if="selectedJob && candidate.email"
        class="card">
        <div class="card-body">
          <CandidateIntervideoInvite />
        </div>
      </div>
    </div>

    <CandidateIntervideoInviteList />
    <CandidateFeed :activityType="'intervideo'" />
   
  </div>

</template>

<script>
import CandidateIntervideoInvite from './CandidateIntervideoInvite'
import CandidateIntervideoInviteList from './CandidateIntervideoInviteList'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateIntervideo',
  components: {
    CandidateIntervideoInvite,
    CandidateIntervideoInviteList,
    CandidateFeed
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Intervideo/CandidateIntervideo.vue